export enum Categories {
  Leave = "leave",
  Absence = "absence",
  GeneralLeave = "general_leave",
  Availability = "availability",
}

export default interface Code {
  id: number
  category: Categories
  client_id: string
  code: string
  deletable?: boolean
  disabled?: boolean
  oid: string
  title: string
  order: number
}

export type postCodeData = Omit<Code, "id">
